function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import styled from 'styled-components';
import { space, fontSize, themeGet } from 'styled-system';
import { ChevronDown } from 'pcln-icons';
import { borders, deprecatedColorValue } from '../utils';
import { Flex } from '../Flex';
var ClickableIcon = styled(ChevronDown).withConfig({
  displayName: "Select__ClickableIcon",
  componentId: "attaz5-0"
})(["pointer-events:none;"]);
var SelectBase = styled.select.withConfig({
  displayName: "Select__SelectBase",
  componentId: "attaz5-1"
})(["appearance:none;display:block;width:100%;font-family:inherit;color:inherit;background-color:transparent;border-radius:", ";border-width:1px;border-style:solid;", " ", " ", "::-ms-expand{display:none;}"], themeGet('radius'), borders, space, fontSize);
SelectBase.defaultProps = {
  fontSize: [2, null, 1],
  m: 0,
  pl: 12,
  pr: 32,
  py: 14
};
SelectBase.propTypes = _objectSpread(_objectSpread(_objectSpread({}, space.propTypes), fontSize.propTypes), {}, {
  color: deprecatedColorValue()
}, borders.propTypes);
var Select = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Flex, {
    width: 1,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(SelectBase, _extends({}, props, {
    ref: ref
  })), /*#__PURE__*/React.createElement(ClickableIcon, {
    ml: -32,
    color: "text.light"
  }));
});
Select.displayName = 'Select';
Select.isField = true;
export default Select;